import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["parent", "child"];

  declare hasParentTarget: boolean;
  declare parentTargets: HTMLInputElement[];
  declare childTargets: HTMLElement[];

  connect(): void {
    if (this.hasParentTarget) {
      this.apply();
    }
  }

  apply(): void {
    for (const parent of this.parentTargets) {
      this.applyParent(parent);
    }
  }

  private applyParent(parent: HTMLInputElement): void {
    const group = parent.dataset["visibleForGroup"];
    const selected = parent.checked === false ? "" : parent.value;

    const children = this.childTargets.filter(c => c.dataset["visibleForGroup"] === group);

    for (const child of children) {
      if (
        (child.dataset["visibleForValue"] !== undefined && child.dataset["visibleForValue"] === selected) ||
        (child.dataset["visibleForValues"] !== undefined && child.dataset["visibleForValues"].split(",").includes(selected))
      ) {
        child.classList.remove('is-hidden');
      } else {
        child.classList.add('is-hidden');
      }
    }
  }
}
